module.exports = __webpack_public_path__ + "static/media/logo_Praktiker.79936324.jpg";